const d = {
  defaultProps: {
    sx: { padding: 2, paddingTop: 1 }
  }
};
export {
  d as dialogActions
};
//# sourceMappingURL=dialogActions3.mjs.map
